import { useTranslation } from "react-i18next";
import { Button, SubmitButton } from "@/shared/ui/core";

export interface PackageFormActionsProps {
  submitLabel: string;
  onCancel: () => void;
}

/**
 * Guardar o salir.
 *
 * El botón de cancelar es `type="button"` (lo es por omisión en el
 * `Button` del sistema): dentro de un `<form>`, un botón sin tipo envía
 * el formulario, y "Cancelar" acabaría guardando.
 *
 * `SubmitButton` saca su estado de carga del propio formulario, así que
 * no hay forma de olvidarse y dejar que se envíe dos veces.
 *
 * La frase de la izquierda dice lo que NO se manda: el precio. Es la
 * pregunta que se hace cualquiera al llegar abajo sin haber visto un
 * campo de precio, y contestarla aquí evita que alguien vuelva arriba a
 * buscarlo.
 */
export function PackageFormActions({ submitLabel, onCancel }: PackageFormActionsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-end gap-3 rounded-2xl border border-ds-border bg-ds-surface px-5 py-4">
      <p className="mr-auto text-[12px] leading-relaxed text-ds-ink-3">
        {t("Se guarda el descuento, no el precio: el precio lo calcula el servidor.")}
      </p>
      <Button variant="ghost" onClick={onCancel}>
        {t("Cancelar")}
      </Button>
      <SubmitButton className="mt-0">{submitLabel}</SubmitButton>
    </div>
  );
}
